import React, {useEffect, useRef, useState} from 'react';
import s from './styles.module.css'
import classNames from "classnames";
import {CircularProgress, Tooltip} from "@mui/material";
import {useStore} from "../../hooks/useStore";
import AlertDialog from "../dialog_modal";
import {toast} from "react-toastify";
import {number} from "sockjs-client/lib/utils/random";

const TableElement = ({
                          showTooltip = false,
                          children,
                          isEdit = false,
                          disabled = false,
                          onChange,
                          onClick,
                          left,
                          right,
                          className,
                          width,
                          isDD = false,
                          tooltipValue,
                          toFixed = 0,
                          index = null,
                          isPreloader = true,
                          isOpen = false,
                          setListScore,
                          isTemp,
                          temp,
                          color,
                      }) => {
    const store = useStore()

    const [edit, setEdit] = useState(false)
    const inputRef = useRef(null);

    const [editValue, setEditValue] = useState(Number(children))
    const [openModal, setOpenModal] = useState(false)

    const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    useEffect(() => {
        if (edit && inputRef.current) {
            inputRef.current.focus();
        }
    }, [edit]);

    useEffect(() => {

        const isInteger = Number(children)?.toString()?.indexOf('.') === -1;
        if (isOpen && isInteger) {
            setEditValue(children !== null ? Number(children)?.toFixed(2) : '')
        } else {
            setEditValue(Number(children))
        }
    }, [edit, store.judging.loadingTable, store.judging.loading])
    return (
        <>
            <AlertDialog
                title={'Вы хотите изменить данное поле?'}
                open={openModal} setOpen={setOpenModal} handlerConfirm={() => {
                setOpenModal(false)
                setTimeout(() => setEdit(true), 100)

            }}/>
            {(!edit && !isOpen) ?
                <Tooltip title={showTooltip ? (tooltipValue ? tooltipValue : children) : null}>
                    <div onClick={() => (onClick && disabled === false) && onClick()}
                         onDoubleClick={() => {
                             ((isEdit && disabled === false && !isDD) && setEdit(true)) ||
                             isDD && setOpenModal(true)
                         }}
                        // className={classNames(s.item, className, isEdit && s.edit, !isEdit && s.close_before, disabled && s.disabled, isTemp && s.blinkBg, isTemp && s.blinkBg2)}
                         className={classNames(s.item, className, isEdit && s.edit, !isEdit && s.close_before, disabled && s.disabled)}
                         style={{
                             minWidth: width,
                             maxWidth: width,
                             width,
                             marginLeft: left,
                             marginRight: right,
                             border: isTemp ? `3px solid ${color}` : 'none',
                             color: isTemp && 'rgb(89 162 229)',
                             background: temp?.isNew && hexToRgba(color, 0.3)
                         }}>
                        {(store.judging.loading) ? <div className={s.preloader}>
                            <CircularProgress/>
                        </div> : (isNaN(+children) ? children : (!children ? '' : Number(children).toFixed(toFixed)))}
                    </div>
                </Tooltip>
                :
                <input type="number"
                       value={editValue}
                       tabIndex={index}
                       disabled={disabled}
                       onChange={(e) => setEditValue(e.target.value)}
                       style={{
                           minWidth: width,
                           maxWidth: width,
                           width,
                           marginLeft: left,
                           marginRight: right
                       }}
                       className={classNames(s.item, className, s.input, disabled && s.disabled)}
                       ref={inputRef}
                       step={0.25} max={10} min={0}
                       onKeyDown={(e) => {
                           if (e.key === "Backspace") {
                               if (editValue.toString()?.split('.')?.length === 1 || !editValue.toString()?.split('.')) return

                               const splitNumber = editValue.toString()?.split('.')
                               setTimeout(() => {
                                   setEditValue(+splitNumber[0])
                               }, 0)

                           }
                           if (e.key === 'Enter' && !isOpen) {
                               setEdit(false)
                               onChange(editValue)
                           }
                           if (e.key === 'Enter') {
                               setEdit(false)
                               setListScore(editValue)
                           }
                       }}

                       onFocus={(event) => event.target.select()}

                    // onBlur={() => {
                    //     if (isOpen) {
                    //         if (Number(editValue) !== Number(children)) {
                    //             setEdit(false)
                    //             setListScore(+editValue)
                    //         } else {
                    //
                    //         }
                    //     } else {
                    //         setEdit(false)
                    //         onChange(+editValue)
                    //     }
                    //
                    //
                    // }}

                       onBlur={() => {
                           const value = editValue === '' ? null : Number(editValue);

                           setEdit(false);

                           if (isOpen) {
                               // В режиме isOpen сохраняем ВСЕГДА при потере фокуса
                               // даже если значение не изменилось (важно для 0 → 0)
                               setListScore(value);
                           } else {
                               // в обычном режиме можно оставить проверку, если нужно
                               onChange(value);
                           }
                       }}
                />}
        </>

    );
};

export default TableElement;
